var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156 156"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 78,
    fill: "#a71680"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2 53.1l39.9 23.8c.5.3.5 1 0 1.3L79.2 102c-.5.3-1.2-.1-1.2-.7V53.8c0-.6.7-1 1.2-.7zM59 53h13v49H59z",
    fill: "#f9af05"
  })));
}
export default SvgScrub;